import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#111111] py-12 px-4" data-id="element-205">
      <div className="max-w-5xl mx-auto" data-id="element-206">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-207">
          <div data-id="element-208">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-209">
              +3.000
            </div>
            <div className="text-gray-300 text-sm font-semibold mt-1" data-id="element-210">
              docentes confían
            </div>
          </div>
          <div data-id="element-211">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-212">12</div>
            <div className="text-gray-300 text-sm font-semibold mt-1" data-id="element-213">
              Tomos completamente listos
            </div>
          </div>
          <div data-id="element-214">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-215">
              4.9/5
            </div>
            <div className="text-gray-300 text-sm font-semibold mt-1" data-id="element-216">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-217">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-218">🇦🇷</div>
            <div className="text-gray-300 text-sm font-semibold mt-1" data-id="element-219">
              Todo el país — primaria y secundaria
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-220">
          <div className="flex items-start gap-3 bg-black/40 border border-white/10 rounded-xl p-4" data-id="element-221">
            <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-222">
              VM
            </div>
            <div data-id="element-223">
              <div className="text-[#33BFA6] text-xs mb-1" data-id="element-224">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-225">
                "Organicé todo el año de Lengua en una tarde"
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-226">
                — Valeria M., Córdoba | Primaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-white/10 rounded-xl p-4" data-id="element-227">
            <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-228">
              CR
            </div>
            <div data-id="element-229">
              <div className="text-[#33BFA6] text-xs mb-1" data-id="element-230">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-231">
                "Mis clases de secundaria por fin tienen estructura real"
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-232">
                — Claudia R., Rosario | Secundaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-white/10 rounded-xl p-4" data-id="element-233">
            <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-234">
              MT
            </div>
            <div data-id="element-235">
              <div className="text-[#33BFA6] text-xs mb-1" data-id="element-236">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-237">
                "Nunca más llegué sin material a clase"
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-238">
                — Marcelo T., Buenos Aires | Primaria y Sec.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}